/**
 * useMailComplaintsBadge (OCP-621) - the number of spam complaints this
 * month, for the badge on the Sends tab. Reads the overview once per
 * MailLayout mount (the overview page fetches its own copy; the second
 * call is the price of a badge that is visible on EVERY mail tab, which is
 * the point). Null while loading / on error / when not reported.
 */
import { useEffect, useState } from 'react';

import { api } from './api';

interface OverviewLite {
  customer_exists?: boolean;
  deliverability?: { reported: boolean; complaints: number | null; level: string } | null;
}

export function useMailComplaintsBadge(enabled: boolean): { complaints: number | null; level: string | null } {
  const [state, setState] = useState<{ complaints: number | null; level: string | null }>({ complaints: null, level: null });
  useEffect(() => {
    if (!enabled) return;
    const ac = new AbortController();
    void (async () => {
      try {
        const r = await api<OverviewLite>('/v1/portal/mail/overview', { signal: ac.signal });
        const d = r.deliverability;
        if (d && d.reported && d.complaints !== null) setState({ complaints: d.complaints, level: d.level });
      } catch {
        /* a badge never blocks the layout */
      }
    })();
    return () => ac.abort();
  }, [enabled]);
  return state;
}
